<script setup>
// Fork Oito: "Minha fila" como painel lateral por cima da tela (igual ao painel de contatos),
// para a consultora ver o que fazer sem sair da conversa.
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { funilAberto } from './funilDrawer';

const router = useRouter();
const route = useRoute();
const montado = ref(false);

watch(funilAberto, v => {
  if (v) montado.value = true;
});

const fechar = () => {
  funilAberto.value = false;
};

const onMessage = e => {
  if (e.origin !== window.location.origin) return;
  const d = e.data || {};
  if (d.tipo === 'oito-abrir-conversa' && d.conv) {
    router.push(
      `/app/accounts/${route.params.accountId}/conversations/${d.conv}`
    );
  }
  if (d.tipo === 'oito-fechar-painel') fechar();
};
const onKey = e => {
  if (e.key === 'Escape' && funilAberto.value) fechar();
};

onMounted(() => {
  window.addEventListener('message', onMessage);
  window.addEventListener('keydown', onKey);
});
onBeforeUnmount(() => {
  window.removeEventListener('message', onMessage);
  window.removeEventListener('keydown', onKey);
});
</script>

<template>
  <div>
    <div
      v-if="montado"
      v-show="funilAberto"
      class="fixed top-0 bottom-0 z-50 flex flex-col w-[460px] max-w-full border-l shadow-xl ltr:right-0 rtl:left-0 bg-n-solid-2 border-n-weak"
    >
      <iframe src="/crm/fila.html?painel=1" class="flex-1 w-full border-0" />
    </div>
  </div>
</template>
